package se.mittpass.web.pages

import se.mittpass.web.*
import se.mittpass.web.components.*
import se.mittpass.web.pages.*
import se.mittpass.web.viewmodel.*
import se.mittpass.web.style.*


import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.dom.*

@Composable
fun LandingPage(onLogin: () -> Unit, onSignUp: () -> Unit = {}, onDemoLogin: () -> Unit = {}, onPrivacy: () -> Unit = {}, onTerms: () -> Unit = {}, onDpa: () -> Unit = {}, onNavigate: (String) -> Unit = {}) {
    Div({
        style {
            property("min-height", "100vh")
            property("font-family", "'DM Sans', system-ui, sans-serif")
        }
    }) {
        LandingHeader(onLogin = onLogin, onSignUp = onSignUp, onNavigate = onNavigate)
        LandingHero(onLogin = onLogin, onSignUp = onSignUp, onDemoLogin = onDemoLogin)
        LandingTrustBar()
        LandingPhotoSection()
        LandingHowItWorks()
        LandingFeatures()
        LandingWhy()
        LandingFounderNote()
        LandingSignUp(onSignUp = onSignUp)
        LandingPricing(onSignUp = onSignUp)
        LandingFaq()
        LandingContact()
        LandingFooter(
            onPrivacy = onPrivacy,
            onTerms = onTerms,
            onDpa = onDpa,
            onDeleteAccount = { onNavigate("delete-account") },
            onSupport = { onNavigate("support") },
            onNavigate = onNavigate
        )
    }
}
